// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__eS_yO","spin":"style_spin___ZVTI"};